<template>
  <div class="md-layout">

    <md-subheader>Actions:</md-subheader>

    <loading-icon-button
      @click="refreshRoles(true)"
      tooltip="Refresh"
      :loading="progress_indicator.loading"
    >
      cached
    </loading-icon-button>
    <loading-icon-button
      @click="createRole"
      tooltip="Create"
    >
      add
    </loading-icon-button>
    <loading-icon-button
      @click="saveRoles"
      tooltip="Save"
      :loading="progress_indicator.saving"
    >
      save
    </loading-icon-button>
    <div class="wrapper">
      <table class="data-table wide">
        <thead>
        <tr>
          <th>Role</th>
          <th v-for="role in roles" :key="role.name">{{ role.name }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="permission in permissions" :key="permission">
          <td>{{ permission }}</td>
          <td v-for="role in roles" :key="role.name">
            <md-checkbox v-model="role.permissions[permission]"></md-checkbox>
          </td>
        </tr>
        </tbody>
      </table>
    </div>


  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import QueryDialog from "@/components/Dialogs/QueryDialog";
import LoadingIconButton from '@/components/LoadingIconButton';

export default {
  components: {
    LoadingIconButton,
  },
  data() {
    return {
      roles: [],
      progress_indicator: {
        loading: false,
        saving: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      savedRoles: 'administrationRolesMatrix',
      permissions: 'administration_permissions',
    }),
  },
  methods: {
    async refreshRoles(force=false){
      this.progress_indicator.loading = true;

      await this.$store.dispatch('fetch_administration_roles', force);
      this.roles = this.savedRoles();

      this.progress_indicator.loading = false;
    },
    async saveRoles(){
      this.progress_indicator.saving = true;

      let roles = this.roles.map( role => {
        return {
          name: role.name,
          permissions: Object.entries(role.permissions).filter( ([k,v]) => v ).map( ([k,v]) => k ),
        };
      } );

      await this.$store.dispatch('store_administration_roles', roles);

      await this.$store.dispatch('fetch_types', { params: { types: ['roles'] } });

      this.progress_indicator.saving = false;
    },
    createRole(){
      let self = this;

      this.$root.$modal.show(QueryDialog, { title: 'New Role Name', queries: { Name: String } })
        .then(({ Name: name }) => {

          if(name){
            self.roles.push({
              name,
              permissions: Object.fromEntries(self.permissions.map( p => [p, false] )),
            });
          }

        })
        .catch(e => {});
    },
  },
  async created(){
    this.refreshRoles();
  },
};
</script>

<style scoped lang="scss">
  @import "@/assets/scss/theme.scss";
  thead {
    position: sticky;
    top: 0;
    z-index: 20;
    background: $ausloans-grey;
  }
  .wrapper {
    width: 100%;
    height: 80vh;
    overflow-y: scroll;
  }
</style>

